export default __webpack_public_path__ + "static/media/ht.e95dd9dc.jpg";